export default __webpack_public_path__ + "static/businnes_graph_rotated-fa18e48d4f52432e82f7b1884ebbefb4.png";